import merge from "lodash/merge";
import Tooltip from "./Tooltip";
import Palette from "../palette";

export default function ComponentsOverrides(theme) {
  const paletteComponents = Palette().components;
  return merge(paletteComponents, Tooltip(theme));
}
